import { api } from "./Api";

const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

export type PlanType = "insight" | "connection" | "meet" | "pulse" | "wave" | "none";

/** Status da análise manual dos documentos (docs + selfie) */
export type DocumentStatus = "not_sent" | "pending" | "approved" | "rejected";

export interface IDashboardEstablishment {
  id: string;
  name: string;
  image: string | null;
  addressInGoogleFormat: string;
}

export interface IDashboardStats {
  // CONNECTION + MEET
  totalCheckins?: number;
  peakHours?: { hour: number; label: string; count: number }[];
  topInterests?: { name: string; count: number }[];
  topLanguages?: { name: string; count: number }[];
  // CONNECTION + MEET
  returningUsers?: number;
  bestDays?: { day: number; label: string; count: number }[];
  avgStayMinutes?: number | null;
  // MEET only — real-time (hoje)
  activeUsers?: number;
  activeMeets?: number;
}

export interface IDashboardData {
  planType: PlanType;
  planName: string | null;

  // ── Degustação ──────────────────────────────────────────────────────────
  /** Data em que o período gratuito termina (Insight 3 meses / Connection 15 dias) */
  trialEndsAt: string | null;
  trialActive: boolean;
  /** Dias restantes de degustação. null quando o plano não tem trial. */
  trialDaysLeft: number | null;

  // ── Análise de documentos ───────────────────────────────────────────────
  documentsStatus: DocumentStatus;
  documentsApproved: boolean;

  // ── Áreas liberadas ─────────────────────────────────────────────────────
  /** Banner e Push só abrem após a aprovação manual dos documentos */
  allowsBanner: boolean;
  allowsPush: boolean;
  pushLimits: { online: number; offline: number };
  establishments: { userEstabilishmentId: string; id: string; name: string }[];
  selectedId: string;
  establishment: IDashboardEstablishment;
  stats: IDashboardStats;
  support: { email: string; whatsapp?: string };
}

export interface IRestDashboard {
  data: { code: number; message: string; data: IDashboardData };
}

export interface IDashboardFilters {
  establishmentId?: string;
  startDate?: string; // YYYY-MM-DD
  endDate?: string;   // YYYY-MM-DD
}

export const getEstablishmentDashboard = (filters: IDashboardFilters = {}) => {
  const params = new URLSearchParams();
  if (filters.establishmentId) params.append("establishmentId", filters.establishmentId);
  if (filters.startDate)       params.append("startDate", filters.startDate);
  if (filters.endDate)         params.append("endDate", filters.endDate);
  const qs = params.toString() ? `?${params.toString()}` : "";
  return api.get(`/pt_BR/establishment/dashboard${qs}`, authHeader());
};